export default "__VITE_ASSET__ade4145b__"